//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class RepertoirePerformanceUpdateItem extends ItemBase {
    Event?: string | null;
    Grade?: string | null;
    Note?: string | null;
    PerformanceDate?: string;
    RepertoireID?: string | null;
    StudentID?: string | null;

    constructor(initializer?: Partial<RepertoirePerformanceUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoirePerformanceUpdateItem";
}
